/**
 * Resolve a rota "home" do usuário com base em suas roles.
 * Mantém um único ponto de verdade para evitar links indiretos a /dashboard
 * (que era apontado pelo logo do sidebar e fallbacks de rota).
 *
 * Regra: admin sempre vai ao /dashboard; demais perfis priorizam seus portais.
 */
export type AppRoleLike = string;

export function resolverHome(papeis: ReadonlyArray<AppRoleLike> | null | undefined): string {
  const roles = papeis ?? [];
  if (roles.includes('admin')) return '/dashboard';
  if (roles.includes('coordenacao')) return '/portal/coordenacao';
  if (roles.includes('professor')) return '/portal/professor';
  if (roles.includes('aluno')) return '/portal/aluno';
  return '/dashboard';
}
